import React, { Component } from 'react';
import { Table, Space, message, Popconfirm, Typography } from 'antd';
import './style.less';
import send from '../../util/request';
import CpAddressModal from '../../components/CpAddressModal';
import CpEmpty from '../../components/CpEmpty';

class addressList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      list: [],
      emptyStatus: '',
      loading: true
    };
  }
  columns = [
    {
      title: '收货人',
      dataIndex: 'username',
      key: 'username',
      align: 'center',
    },
    {
      title: '联系方式',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
    },
    {
      title: '地址',
      dataIndex: 'address',
      key: 'address',
      align: 'center',
      width: 300
    },
    {
      title: '收货仓库',
      dataIndex: 'warehouse',
      key: 'warehouse',
      align: 'center',
      width: 200,
      render:(text)=>text?.warehouse_name
    },
    {
      title: '是否默认',
      dataIndex: 'isDefault',
      key: 'isDefault',
      align: 'center',
      render: (val) => {
        return val === 1 ? '是' : '否';
      }
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <Space size="middle">
          <Typography.Link onClick={() => this.handleAreaModalEdit(record)}>编辑</Typography.Link>
          <Popconfirm title="删除该地址后，地址相关的计划提报信息将被同步删除，是否删除地址？" onConfirm={() => this.handleAreaDel(record)} okText="确认" cancelText="取消"><Typography.Link >删除</Typography.Link></Popconfirm>
        </Space>
      ),
    },
  ]

  componentDidMount() {
    this.getAddressList();
  }
  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }
  record = {}
  handleAreaModalEdit = (record) => {
    this.setState({
      visible: true,
    });
    this.record = record;
  }
  handleAreaDel = (record) => {
    send({
      url: '/ipp/user-address/delete',
      method: "GET",
      params: {
        id: record.id || '',
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(res.data.msg, .5, this.getAddressList());
      } else {
        message.error(res.data.msg);
      }
    });
  }
  getAddressList = () => {
    send({
      url: '/ipp/user-address/select',
      method: 'GET',
      options: { loading: true }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        const { list = [] } = res.data.data;
        let data = [];
        list.forEach(item => {
          data.push({
            ...item,
            address: item.address,
            id: item.id,
            areaId: item.area_id,
            areaName: item.area_name,
            cityId: item.city_id,
            cityName: item.city_name,
            createTime: item.create_time,
            isDefault: item.is_default,
            phone: item.phone,
            postalCode: item.postal_code,
            countryId: item.country_id,
            countryName: item.country_name,
            provinceId: item.province_id,
            provinceName: item.province_name,
            updateTime: item.update_time,
            userId: item.user_id,
            username: item.username
          });
        });
        this.setState({
          list: data,
          emptyStatus: list.length ? '' : 'address',
          loading: false
        });
      }
    }, err => {
      this.setState({ loading: false });
    });
  }
  handleAreaModalAdd = () => {
    this.setState({
      visible: true
    });
  }
  hideModal = () => {
    this.setState({ visible: false });
    this.record = {};
  }
  submitModal = () => {
    this.setState({ visible: false });
    this.record = {};
    this.getAddressList();
  }
  render() {
    const { visible, list, emptyStatus, loading } = this.state;

    const empty = (
      <div className="address-empty">
        <CpEmpty status={emptyStatus} history={this.props.history} onClicked={this.handleAreaModalAdd} />
      </div>
    );
    return (
      <div className="address-list">
        <div className="address-list-title">
          <span className="title">收货地址</span>
          {list.length > 0 && <span className="address-list-btn pointer" onClick={this.handleAreaModalAdd}>新增收货地址</span>}
        </div>
        {
          (list.length <= 0 && emptyStatus.length) ? empty :
            <Table
              rowKey="id"
              columns={this.columns}
              dataSource={list}
              pagination={false}
              loading={loading}
              className={'address-list-table'}
            />
        }
        {
          visible ? <CpAddressModal
            record={this.record}
            hideModal={this.hideModal}
            submitModal={this.submitModal}>
          </CpAddressModal> : null
        }
      </div>
    );
  }
}
export default addressList;